import { render, staticRenderFns } from "./VerifyIdentityComponent.vue?vue&type=template&id=4b48d4e3&scoped=true&"
import script from "./VerifyIdentityComponent.vue?vue&type=script&lang=js&"
export * from "./VerifyIdentityComponent.vue?vue&type=script&lang=js&"
import style0 from "./VerifyIdentityComponent.vue?vue&type=style&index=0&id=4b48d4e3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b48d4e3",
  null
  
)

export default component.exports